<template>
    <Toolbar v-if="data.toolbar !== undefined" :class="data.toolbar.class || 'bg-white p-0'" class="w-100">
        <template #start>
            <div v-if="data.toolbar.leftSide && data.toolbar.leftSide.buttons">
                <template v-for="(item, index) in data.toolbar.leftSide.buttons">
                    <template v-if="item.private === undefined || !item.private">
                        <button
                            v-if="item.type === undefined || item.type == 'button'"
                            :class="`me-sm-2 btn ${item.class}`"
                            :title="item.title !== undefined ? item.title : ''"
                            @click="item.eventCallback ? item.eventCallback(parentobj, $event) : undefined"
                            :key="index"
                        >
                            <i :class="`me-1 ${item.icon}`"></i>
                            {{item.label}}
                        </button>
                        <router-link
                            v-else-if="item.type !== undefined && item.type == 'link'"
                            :class="`btn ${item.class}`"
                            :title="item.title !== undefined ? item.title : ''"
                            @click="typeof item.eventCallback === 'function' ? item.eventCallback(parentobj, $event) : null"
                            :target="item.target || '_blank'"
                            :to="item.to !== undefined && typeof item.to === 'function' ? item.to(data) : item.to"
                        >
                            <i :class="`pt-13 ${item.icon}`"></i>
                            {{item.label}}
                        </router-link>
                    </template>
                </template>
            </div>
            <div v-if="data.toolbar.footerLeftText" v-html="data.toolbar.footerLeftText"></div>
        </template>
        <template #center>
            <div v-if="data.toolbar.centerSide && data.toolbar.centerSide.buttons">
                <template v-for="(item, index) in data.toolbar.centerSide.buttons">
                    <button
                        v-if="item.private === undefined || !item.private"
                        :class="`me-sm-2 btn ${item.class}`"
                        :title="item.title !== undefined ? item.title : ''"
                        @click="item.eventCallback ? item.eventCallback(parentobj, $event) : undefined"
                        :key="index"
                    >
                        <i :class="`me-1 ${item.icon}`"></i>
                        {{item.label}}
                    </button>
                </template>
            </div>
            <div v-if="data.toolbar.footerCenterText" v-html="data.toolbar.footerCenterText"></div>
        </template>
        <template #end>
            <div v-if="data.toolbar.rightSide && data.toolbar.rightSide.buttons">
                <template v-for="(item, index) in data.toolbar.rightSide.buttons" >
                    <button
                        v-if="item.private === undefined || !item.private"
                        :class="`me-sm-2 btn ${item.class}`"
                        :title="item.title !== undefined ? item.title : ''"
                        @click="item.eventCallback ? item.eventCallback(parentobj, $event) : undefined"
                        :key="index"
                    >
                        <i :class="`me-1 ${item.icon}`"></i>
                        {{item.label}}
                    </button>
                </template>
            </div>
            <div v-if="data.toolbar.footerRightText" v-html="data.toolbar.footerRightText"></div>
        </template>
    </Toolbar>
</template>


<script>
    import { onMounted } from 'vue';

    import Toolbar from "primevue/toolbar";

    import { useModelWrapper } from "@/system_modules/utils/modelWrapper";

    export default {
        name: 'DAToolbar',
        props: {
            data: {
                type: Object,
                default() {
                    return {
                        toolbar: {
                            rightSide: {
                                buttons: [
                                    {
                                        label: '',
                                        icon: "fas fa-times",
                                        class: "btn-secondary",
                                        eventCallback: (pobj, event) => {
                                            pobj.close(pobj, event);
                                        },
                                    },
                                ]
                            }
                        }
                    };
                }
            },
            mainref: {
                type: Object,
                default(){
                    return null;
                },
            },
        },
        components: {
            Toolbar,
        },
        setup(props, { emit }) {
            const parentobj = useModelWrapper(props, emit, "mainref");

            onMounted(() => {
                parentobj['data_value'] = props.data;
            });

            return {
                parentobj,
            };
        },
    };
</script>

<style lang="scss" scoped>
    .p-toolbar {
        padding: 0.8rem;
        border: unset;
    }
</style>
